module.exports = __webpack_public_path__ + "media/form-type-page/wallet-f5bd0422.svg";